import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';

/** The first path segment of a URL or of a router link — what a nav item's `route` is written as. */
export const navSegment = (path: string): string => path.split(/[?#]/)[0].split('/').filter(Boolean)[0] ?? '';

/**
 * The segment of the page on screen, re-read after every navigation.
 *
 * The nav surfaces ask this rather than leaning on `routerLinkActive`, which
 * can only match a link against its own URL: an item that stands for more than
 * one segment — Profile, which is also where Settings is reached from — needs
 * the segment itself. See `isNavItemActive`.
 */
export const injectNavSegment = (): Signal<string> => {
  const router = inject(Router);

  return toSignal(
    router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => navSegment(router.url)),
    ),
    { initialValue: navSegment(router.url) },
  );
};
